import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formStyleConstants } from '../../utils/constants/form-style-constants';
import { isEmpty } from '../../utils/obj-utils';
import FieldHeader from './FieldHeader';

class FormDateField extends Component {
    constructor(props) {
        super(props);
        const { validState, defaultValue } = this.props;

        this.initialState = {
            day: '', month: '', year: '', isValid: true, errorMessage: ''
        };

        if (validState) {
            this.initialState.isValid = validState.isValid;
            this.initialState.errorMessage = validState.errorMessage;
        }

        if (!isEmpty(defaultValue)) {
            this.initialState.day = defaultValue.getDate();
            this.initialState.month = defaultValue.getMonth() + 1;
            this.initialState.year = defaultValue.getFullYear();
        }

        this.state = this.initialState;
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCallback = this.handleChangeCallback.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.defaultValue === nextProps.defaultValue) {
            return;
        }
        if (isEmpty(nextProps.defaultValue)) return;
        const dayValue = nextProps.defaultValue.getDate();
        const monthValue = nextProps.defaultValue.getMonth() + 1;
        const yearValue = nextProps.defaultValue.getFullYear();

        this.setState((state) => ({
            ...state, day: dayValue, month: monthValue, year: yearValue
        }));
    }

    handleChange(event) {
        const { name, value } = event.target;
        this.setState(
            (prevState) => ({
                ...prevState,
                [name]: value
            }),
            this.handleChangeCallback
        );
    }

    handleChangeCallback() {
        const { onChange } = this.props;
        onChange(this.state);
    }

    render() {
        const {
            validState,
            formRef,
            isHidden,
            headerTitle,
            headerText,
            isDisabled,
            name,
            label
        } = this.props;
        const { day, month, year } = this.state;
        const { isValid, errorMessage } = validState || this.state;
        return (
            <Fragment>
                <FieldHeader fieldName={name} headerTitle={headerTitle} headerText={headerText}></FieldHeader>
                <div
                    ref={formRef}
                    className={`form-date auto-mt-xs ${!isValid ? formStyleConstants.isInvalid : ''}`}
                    style={{ display: isHidden ? 'none' : 'block' }}
                    data-form-control>
                    <label className='form-date__label'>
                        <span className='form-date__title'>{label}</span>
                    </label>
                    <div className='form-date__container'>
                        <input
                            className='form-date__input'
                            type='text'
                            id='day'
                            name='day'
                            placeholder='DD'
                            maxLength='2'
                            pattern='[0-9]*'
                            defaultValue={day}
                            disabled={isDisabled}
                            onChange={this.handleChange}
                            aria-label='Enter day in DD format'
                        />
                        <input
                            className='form-date__input'
                            type='text'
                            id='month'
                            name='month'
                            placeholder='MM'
                            maxLength='2'
                            defaultValue={month}
                            disabled={isDisabled}
                            onChange={this.handleChange}
                            aria-label='Enter month in MM format'
                        />
                        <input
                            className='form-date__input form-date__input--year'
                            type='text'
                            id='year'
                            name='year'
                            placeholder='YYYY'
                            maxLength='4'
                            defaultValue={year}
                            disabled={isDisabled}
                            onChange={this.handleChange}
                            aria-label='Enter year in YYYY format'
                        />
                    </div>
                    {!isValid ? <ul className="form-field__error-list filled">
                        <li className="form-field__error-item">{errorMessage}</li>
                    </ul> : null}
                </div>
            </Fragment>
        );
    }
}

FormDateField.propTypes = {
    formRef: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    headerTitle: PropTypes.string,
    headerText: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    validState: PropTypes.object,
    defaultValue: PropTypes.object
};

export default FormDateField;
